import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Highlight from "../Highlight";

const POPULAR_TAGS = [
  "SDR",
  "Account executive",
  "RevOps",
  "Lifecycle marketing",
  "Virtual assistant",
];

export default function Hero() {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");

  const search = (term) => {
    const q = term.trim();
    navigate(q ? `/search/freelancers?q=${encodeURIComponent(q)}` : "/talent");
  };

  return (
    <header className="mx-auto grid max-w-[1200px] grid-cols-1 gap-x-8 px-6 pb-16 pt-12 lg:grid-cols-[minmax(0,1fr)_240px] lg:px-10 lg:pb-[88px] lg:pt-[72px]">
      <div className="min-w-0 max-w-[760px] lg:col-start-1">
        <div className="mb-7 inline-flex items-center gap-2.5 rounded-full border-[1.5px] border-ink-v2 bg-white px-4 py-[9px] text-[12px] font-bold uppercase leading-none tracking-[0.12em]">
          <span className="h-2 w-2 rounded-full border border-ink-v2 bg-lime-300" />
          Top 5% of African freelance talent · vetted by humans
        </div>
        <h1 className="mb-6 text-balance text-[clamp(48px,7.5vw,112px)] font-extrabold leading-[0.95] tracking-[-0.035em] text-ink-v2">
          Freelancers you can <Highlight>trust</Highlight> with the job.
        </h1>
        <p className="mb-9 max-w-[560px] text-[20px] font-medium leading-[1.5] text-warm-600">
          SDRs, account executives, RevOps analysts and AI-native builders —
          hand-vetted, reference-checked, ready in days. Hire directly, or let us
          run the whole thing.
        </p>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          search(query);
        }}
        className="flex max-w-[640px] items-center rounded-full border-[1.5px] border-ink-v2 bg-white py-1.5 pl-6 pr-1.5 shadow-pop lg:col-start-1"
      >
        <span aria-hidden="true" className="mr-2.5 text-[18px] text-warm-500">
          &#8981;
        </span>
        <input
          type="search"
          aria-label="Search talent"
          placeholder="Try &ldquo;SDR&rdquo; or &ldquo;RevOps analyst&rdquo;&hellip;"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="min-w-0 flex-1 border-none bg-transparent py-3 text-[16px] font-medium leading-none text-ink-v2 outline-none placeholder:text-warm-500"
        />
        <button
          type="submit"
          className="shrink-0 rounded-full bg-ink-v2 px-[18px] py-3.5 text-[15px] font-bold leading-none text-white transition-colors duration-120 hover:bg-coral-500 lg:px-[26px]"
        >
          Search talent
        </button>
      </form>

      <div className="mt-4 flex flex-wrap items-center gap-2 lg:col-start-1">
        <span className="text-[12px] font-medium leading-[1.4] text-warm-500">
          Popular:
        </span>
        {POPULAR_TAGS.map((tag) => (
          <button
            key={tag}
            type="button"
            onClick={() => search(tag)}
            className="rounded-full border border-warm-300 bg-white px-[13px] py-[7px] text-[13px] font-semibold leading-none transition-all duration-120 hover:border-ink-v2 hover:bg-lime-300"
          >
            {tag}
          </button>
        ))}
      </div>

      {/* Sticker collage — a vertical stack on desktop, a plain row on mobile */}
      <div className="mt-10 flex flex-row flex-wrap items-start gap-5 lg:col-start-2 lg:row-span-3 lg:row-start-1 lg:mt-0 lg:w-[240px] lg:flex-col lg:flex-nowrap lg:gap-0 lg:self-start lg:pt-8">
        <div className="h-[170px] w-[170px] shrink-0 overflow-hidden rounded-full border-[1.5px] border-ink-v2 bg-sun-400 shadow-pop">
          <img src="/hero1.jpg" alt="" className="h-full w-full object-cover" />
        </div>
        <div className="h-[130px] w-[130px] shrink-0 overflow-hidden rounded-full border-[1.5px] border-ink-v2 bg-[#FFE3DC] shadow-pop-coral lg:-mt-7 lg:ml-[110px]">
          <img src="/hero2.jpg" alt="" className="h-full w-full object-cover" />
        </div>
        <div className="h-[104px] w-[104px] shrink-0 overflow-hidden rounded-full border-[1.5px] border-ink-v2 bg-[#E4EEFF] shadow-pop-sm lg:-mt-5 lg:ml-3">
          <img
            src="/avatar_female.png"
            alt=""
            className="h-full w-full object-cover"
          />
        </div>
        <div className="w-[150px] shrink-0 -rotate-3 rounded-2xl border-[1.5px] border-ink-v2 bg-lime-300 px-[18px] py-4 shadow-pop motion-safe:animate-cb-float lg:ml-[76px] lg:mt-5">
          <div className="text-[28px] font-extrabold leading-none tracking-[-0.02em]">
            5%
          </div>
          <div className="mt-1.5 text-[13px] font-semibold leading-[1.3]">
            acceptance rate. That&rsquo;s the point.
          </div>
        </div>
      </div>
    </header>
  );
}
